export default "__VITE_ASSET__Bs7xi$mi__"